import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import isNull from 'lodash/isNull';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import type { FormattedPerson } from '../../../../../../onboarding-business-insight.types';
import { EMPTY_VALUE } from '../../../../constants';
type MobileRowProps = {
  person: FormattedPerson;
};
const MobileRow = t0 => {
  const $ = _c(27);
  const {
    person: t1
  } = t0;
  const {
    name,
    role,
    submitted,
    associationVerified,
    sources
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  let t3;
  if ($[1] !== submitted || $[2] !== t) {
    t3 = submitted ? t(_temp) : t(_temp2);
    $[1] = submitted;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const submittedText = t3;
  let t4;
  if ($[4] !== submitted || $[5] !== submittedText) {
    t4 = isNull(submitted) ? EMPTY_VALUE : submittedText;
    $[4] = submitted;
    $[5] = submittedText;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sources || $[8] !== t) {
    t5 = sources === EMPTY_VALUE ? EMPTY_VALUE : t(_temp3, {
      sources
    });
    $[7] = sources;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== role || $[11] !== t4 || $[12] !== t5) {
    t6 = [role, t4, t5].filter(_temp4);
    $[10] = role;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const details = t6;
  let t7;
  if ($[14] !== name) {
    t7 = <span className="min-w-0 text-label-2 text-primary wrap-anywhere">{name}</span>;
    $[14] = name;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== associationVerified || $[17] !== t) {
    t8 = !isNull(associationVerified) && <Badge className="shrink-0" variant={associationVerified ? "success" : "error"}>{associationVerified ? t(_temp5) : t(_temp6)}</Badge>;
    $[16] = associationVerified;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="flex items-start justify-between gap-3">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== details) {
    t10 = details.length > 0 && <span className="text-body-3 text-tertiary wrap-anywhere">{details.map(_temp7)}</span>;
    $[22] = details;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <td><div className="flex flex-col gap-0.5 py-2 whitespace-normal">{t9}{t10}</div></td>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default MobileRow;
function _temp($) {
  return $.businessShared.tags.submitted;
}
function _temp2($_0) {
  return $_0.businessShared.tags.notSubmitted;
}
function _temp3($_1) {
  return $_1.businessDetails.name.table.source;
}
function _temp4(detail) {
  return detail !== EMPTY_VALUE;
}
function _temp5($_2) {
  return $_2.businessShared.tags.verified;
}
function _temp6($_3) {
  return $_3.businessShared.tags.notVerified;
}
function _temp7(detail_0, index) {
  return <Fragment key={detail_0}>{index > 0 && " \xB7 "}<span className="inline-block">{detail_0}</span></Fragment>;
}